import React from 'react';
import { useTranslation } from '@fluentsms/i18n';
import { FormControl, FormControlLabel, makeStyles, Switch, Theme, Typography } from '@material-ui/core';
import { ColumnFilter } from '../DataGridFilterMenu';
import { SearchBar } from '../SearchBar';
import FilterMenu from './FilterMenu';
import { FilterColumns, TableFilter } from './types/filterTypes';

const useStyles = makeStyles((theme: Theme) => ({
  filterContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  filterMenu: {
    width: 310,
  },
  filterItem: {
    marginBottom: theme.spacing(3),
  },
  filterActions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  labelControlSwitch: {
    marginLeft: theme.spacing(1),
  },
  switchDetails: {
    marginLeft: theme.spacing(1.8),
    marginRight: `${theme.spacing(0)}px !important`,
  },
  searchInput: {
    width: 200,
    marginLeft: theme.spacing(2.8),
  },
  closeIcon: {
    cursor: 'pointer',
  },
}));

type QueryMultiFilterMenuProps = {
  disableMenu?: boolean;
  enableDetailsSwitch?: boolean;
  checked?: boolean;
  onSwitchChange?: (checked: boolean) => void;
  columns?: FilterColumns[];
  filters?: TableFilter[];
  onFilterChange?: (filters: TableFilter[]) => void;
  searchTerm?: string;
  onSearchChange?: (searchValue: string) => void;
};

export const QueryMultiFilterMenu = (props: QueryMultiFilterMenuProps) => {
  const classes = useStyles();
  const { t } = useTranslation('documents');
  const {
    disableMenu,
    searchTerm = '',
    onSearchChange = (value: string) => undefined,
    filters = [],
    onFilterChange = (filters: TableFilter[]) => undefined,
    enableDetailsSwitch,
    checked,
    onSwitchChange,
    columns = [],
  } = props;

  const onHandleSelectedFilters = (currFilters: ColumnFilter[]) => {
    onFilterChange(currFilters as TableFilter[]);
  };

  const onReset = () => {
    onFilterChange([] as TableFilter[]);
  };

  return (
    <div className={classes.filterContainer} data-testid="query-filter-menu">
      {!disableMenu && (
        <FilterMenu columns={columns} filters={filters} onSubmit={onHandleSelectedFilters} onReset={onReset} />
      )}
      {enableDetailsSwitch && (
        <FormControlLabel
          label={<Typography variant="body2">{'Details'}</Typography>}
          labelPlacement="start"
          className={classes.labelControlSwitch}
          control={
            <Switch
              checked={checked}
              className={classes.switchDetails}
              size="small"
              onChange={(_, checked) => onSwitchChange?.(checked)}
              name="checkedA"
              color="primary"
            />
          }
        />
      )}
      <FormControl className={classes.searchInput}>
        <SearchBar
          placeholder={t('addTemplateDrawer.searchPlaceholder')}
          fullWidth
          searchString={searchTerm}
          onSearchChange={onSearchChange}
          style={{ paddingLeft: '8px' }}
          autoFocus
        />
      </FormControl>
    </div>
  );
};
